export enum HospitalRequestStatus {
  Requested = 'Requested',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}
